var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repeat } from 'lit/directives/repeat.js';
import { property, query, state } from 'lit/decorators.js';
import { html, css } from 'lit';
import { submitEventHandler, customElement, parseContextArr, PIC, PICBase, PICAction } from '../Internals';
import { computePosition, size, flip } from '@floating-ui/dom';
let PICContext = class PICContext extends PICBase {
    constructor() {
        super();
        this.mode_ = 'table';
        this.globflag_ = undefined;
        this.contextOpts = [];
        this.display = 'none';
        this.shouldHide = true;
        this.isinput__ = false;
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                /* Flips the menu's native chrome (scrollbar, hr) for dark mode */
                color-scheme: var(--pic-colorScheme, light);
                --contextLineHoverColor: var(--pic-primaryHoverColor, #ffffff);
                --contextLineTextHoverColor: var(--pic-onSurfaceHighColor, #000000);
                --pic-contextDisabledBGColor: var(--pic-primaryActiveColor);
                --pic-contextDisabledColor: var(--pic-disabledBGColor);
                --pic-contextDiabledBorderColor: var(--pic-blackOverlayFocusColor);
            }
            .pic-contextmenu{
                position: fixed;
                display: none;
                background-color: var(--pic-surfaceColor, #F8F8F8);
                height: auto;
                z-index: 9999999;
                margin: 0;
                border: 1px solid var(--pic-outline, lightgrey);
                max-height: var(--ctx-h, 90vh);
                overflow-y: auto;
            }
            .pic-contextmenu p {
                margin: 0;
                cursor: pointer;
                border-bottom: 1px solid var(--pic-outline, #E8E8E8);
                padding-left: 10px;
                padding-right: 10px;
                color: var(--pic-onSurfaceHighColor, black);
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 160px;
            }
            .pic-contextmenu .hide{
                display: none;
            }
            .pic-contextmenu .show{
                display: block;
            }
            .pic-contextmenu p:hover {
                background-color: var(--contextLineHoverColor, #FFFFFF);
                color: var(--contextLineTextHoverColor, black);
            }
            p{
                font-family: var(--override);
                white-space: nowrap;
            }
            .chevron::after{
                font-family: 'Material Design Icons';
                font-size: 20px;
            }
            .chevron.right::after{
                content: '\u{F0142}';
            }
            .chevron.left::after{
                content: '\u{F0141}';
            }
            .subhead:hover > .sublist{
                display: block;
                max-height: var(--ctx-s-h);
            }
            .sublist{
                box-sizing: border-box;
                display: none;
                position: fixed;
                left: var(--ctx-s-l);
                top: var(--ctx-s-t);
            }
            .pic-contextmenu p[disabled], .pic-contextmenu .subhead[disabled] p{
                /* background-color: var(--pic-contextDisabledBGColor); */
                /* border-color: var(--pic-contextDiabledBorderColor); */
                color: var(--pic-contextDisabledColor);
                pointer-events: none;
            }
            .pic-contextmenu hr{
                margin: 0;
            }


        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        this._closeListener = (e) => { this.closeListener(e); };
        if (this._closeListener) {
            ['contextmenu', 'wheel', 'click'].forEach(eventStr => {
                window.addEventListener(eventStr, this._closeListener);
            });
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._closeListener) {
            ['contextmenu', 'wheel', 'click'].forEach(eventStr => {
                window.removeEventListener(eventStr, this._closeListener);
            });
        }
    }
    openContext() {
        if (this.initClick) {
            this.display = "block";
            this.handleOpen();
        }
    }
    handleOpen() {
        let tRef = this;
        let refrenceElm = this.virtualElm ? this.virtualElm : this.clickedElm ? this.clickedElm : undefined;
        if (refrenceElm) {
            computePosition(refrenceElm, this.innerDiv, {
                placement: this.getPlacement(refrenceElm, this.innerDiv),
                strategy: 'fixed',
                middleware: [
                    size({
                        apply({ availableHeight }) {
                            tRef.style.setProperty('--ctx-h', `${availableHeight - 130}px`);
                        }
                    }),
                    flip({ fallbackStrategy: 'initialPlacement' }),
                ] /*, platform: {
                    ...platform,
                    getOffsetParent: (element) => platform.getOffsetParent(element, offsetParent),
                }*/
            }).then(({ x, y }) => {
                this.style.setProperty('--ctx-l', `${x}px`);
                this.style.setProperty('--ctx-t', `${y}px`);
            });
        }
    }
    updated(_changedProperties) {
        this.handleOpen();
    }
    closeListener(e) {
        var _a;
        let eventInside = false;
        if (e.target.renderRoot) {
            if (e.target == this) {
                eventInside = true;
            }
            else if (e.composedPath()[0] == ((_a = this.initClick) === null || _a === void 0 ? void 0 : _a.composedPath()[0])) {
                eventInside = true;
            }
            else {
                eventInside = e.composedPath().includes(this);
            }
        }
        if (!eventInside && this.display !== 'none') {
            this.shouldHide = true;
            this.closeContext();
        }
    }
    /* close ContextMenu */
    closeContext() {
        this.hide();
    }
    hide() {
        if (this.shouldHide) {
            this.display = "none";
            PIC.getInstance.events.activePicker = undefined;
            this.requestUpdate();
        }
        else {
            this.shouldHide = true;
        }
    }
    /* show ContextMenu */
    set data(iData) {
        if (iData.clickEvent) {
            this.initClick = iData.clickEvent;
            this.clickedElm = iData.clickEvent.composedPath()[0];
            this.virtualElm = {
                getBoundingClientRect() {
                    var _a, _b, _c, _d, _e, _f;
                    return {
                        width: 0,
                        height: 0,
                        x: (_a = iData.clickEvent) === null || _a === void 0 ? void 0 : _a.clientX,
                        y: (_b = iData.clickEvent) === null || _b === void 0 ? void 0 : _b.clientY,
                        left: (_c = iData.clickEvent) === null || _c === void 0 ? void 0 : _c.clientX,
                        right: (_d = iData.clickEvent) === null || _d === void 0 ? void 0 : _d.clientX,
                        top: (_e = iData.clickEvent) === null || _e === void 0 ? void 0 : _e.clientY,
                        bottom: (_f = iData.clickEvent) === null || _f === void 0 ? void 0 : _f.clientY,
                    };
                }
            };
        }
        if (iData.overrideFont)
            this.overrideFont = iData.overrideFont;
        else
            this.overrideFont = '';
        let ref = this;
        if (iData.context) {
            if (this.mode_ == 'table') {
                iData.context.forEach(con => {
                    if (con.choiceBox instanceof Array) {
                        con.choiceBox = con.choiceBox[0];
                    }
                    if (con.eventFncKey === 'loadPage') {
                        let lpAction = new PICAction();
                        lpAction.type_ = 'loadPage';
                        let evtArr = con.eventTxt.split(',');
                        lpAction.progpath_ = evtArr && evtArr.length > 0 ? evtArr[0] : con.eventTxt;
                        lpAction.parms_ = evtArr && evtArr.length > 1 ? evtArr[1] : '';
                        if (iData.selectedValues)
                            lpAction.parms_ += ',selectedvalues=' + iData.selectedValues;
                        con.eventFnc = lpAction;
                    }
                    else if (con.eventFncKey === 'doSubmit' && iData.selectedValues) {
                        con.eventFnc = (e) => {
                            submitEventHandler(e, con.eventTxt);
                        };
                    }
                });
            }
            this.contextOpts = iData.context;
            this.contextPromise = undefined;
        }
        if (iData.contextPromise) {
            this.contextOpts = [];
            iData.contextPromise.then((res) => {
                return parseContextArr(res, { callBackFunction: () => { }, parentElmRef: ref });
            }).then((res) => {
                if (iData.postPromiseContext)
                    res = res.concat(iData.postPromiseContext); //Add additional (js) context menues after promise resolves
                this.contextOpts = res;
                this.requestUpdate();
            });
        }
        this.openContext();
        this.requestUpdate();
    }
    renderSubHead(iContext, iIndex) {
        //determine if chevron should be left F0141 or right F0142 depending on available space around the context menu
        return html `
            <div 
                class="subhead" 
                @click=${iContext.disabled ? () => { } : mobileClick}
                ?disabled=${iContext.disabled}
                @mouseenter=${iContext.disabled ? () => { } : (e) => { compPos(e, this); }}
                >
                <p
                    style="${this.overrideFont ? '--override:' + this.overrideFont : ''}" 
                    class="chevron right">
                    ${iContext.menuTxt}
                </p>
                ${iContext.disabled ? '' : html `<div class="sublist pic-contextmenu">${this.renderContextList(iContext.subContext)}</div>`}
            </div>
        `;
        function mobileClick(e) {
            let candidateArr = e.composedPath().filter((elm) => { var _a; return (_a = elm === null || elm === void 0 ? void 0 : elm.classList) === null || _a === void 0 ? void 0 : _a.contains('subhead'); });
            let t;
            if (candidateArr.length > 0) {
                t = candidateArr[0];
                if (t.classList.contains('clicked'))
                    t.classList.remove('clicked');
                else
                    t.classList.add('clicked');
            }
            else
                return;
        }
        function compPos(e, tRef) {
            let subhead = e.target;
            let list = subhead.lastElementChild;
            let place = tRef.getPlacement(subhead, list);
            if (place.includes('left')) {
                subhead.firstElementChild.classList.add('left');
                subhead.firstElementChild.classList.remove('right');
            }
            else {
                subhead.firstElementChild.classList.add('right');
                subhead.firstElementChild.classList.remove('left');
            }
            computePosition(subhead, list, {
                placement: place,
                strategy: 'fixed',
                middleware: [
                    size({
                        apply({ availableHeight }) {
                            list.style.setProperty('--ctx-s-h', `${(availableHeight - 30)}px`);
                        }
                    }),
                    flip({ fallbackStrategy: 'initialPlacement' }),
                ]
            }).then(({ x, y }) => {
                list.style.setProperty('--ctx-s-l', `${x}px`);
                list.style.setProperty('--ctx-s-t', `${y}px`);
            });
        }
    }
    getPlacement(reference, floating) {
        let LeftOrRight = 'right';
        let UpOrDown = 'end';
        if (reference && floating) {
            if (reference.getBoundingClientRect().top < (window.innerHeight / 2))
                UpOrDown = 'start';
            if ((window.innerWidth - reference.getBoundingClientRect().right) < floating.getBoundingClientRect().width)
                LeftOrRight = 'left';
        }
        return `${LeftOrRight + '-' + UpOrDown}`;
    }
    renderContextItem(iContext, iIndex) {
        if (iContext.choiceBox instanceof Array) {
            iContext.choiceBox = iContext.choiceBox[0];
        }
        if (iContext.eventFncKey == 'subMenu' && iContext.subContext) {
            return this.renderSubHead(iContext, iIndex);
        }
        else if (iContext.eventFncKey === 'lineSeperator') {
            return html `<hr>`;
        }
        else {
            return html `
                <p style="${this.overrideFont ? '--override:' + this.overrideFont : ''}" 
                ?disabled=${iContext.disabled}
                @click=${iContext.disabled ? (e) => { } : (e) => clickFunction(e, iContext, this)}>
                    ${iContext.menuTxt}
                </p>
            `;
        }
        function clickFunction(e, iCon, iRef) {
            var _a;
            if (iCon.eventFnc === undefined) {
                if (iCon.choiceBox) {
                    iRef.closeContext();
                    submitEventHandler(e, iContext.eventTxt, {
                        choiceBox: {
                            hasChoiceBox: iContext.choiceBox ? true : false,
                            isDefaultBox: false,
                            customBox: iContext.choiceBox //?
                        }
                    });
                }
                else {
                    iRef.closeContext();
                    submitEventHandler(e, iContext.eventTxt);
                }
            }
            else {
                if (iCon.choiceBox) {
                    iRef.closeContext();
                    (_a = iCon.choiceBox.choices) === null || _a === void 0 ? void 0 : _a.forEach(c => {
                        if (c.choiceText == 'Yes') {
                            c.eventFnc = iCon.eventFnc;
                        }
                    });
                    submitEventHandler(e, iContext.eventTxt, {
                        choiceBox: {
                            hasChoiceBox: iContext.choiceBox ? true : false,
                            isDefaultBox: false,
                            customBox: iContext.choiceBox //?
                        }
                    });
                }
                else if (iCon.eventFnc) {
                    if (!(typeof iCon.eventFnc === 'string' || iCon.eventFnc instanceof String)) {
                        if (iCon.eventFnc instanceof PICAction)
                            iCon.eventFnc.triggerEvent(e);
                        else
                            iCon.eventFnc(e);
                        iRef.closeContext();
                    }
                }
                else
                    console.error('Missing contextFunction: ' + iCon.contextId + ' ' + iCon.eventTxt);
            }
        }
    }
    ;
    renderContextList(iContextLst, resolved) {
        return html `${repeat(iContextLst, (opt) => opt, (opt, index) => this.renderContextItem(opt, index))}`;
    }
    ;
    render() {
        return html `
            ${this.renderCSS(true)}
            <div 
                id="pic-contextMenu" 
                class="pic-contextmenu pic-body2" 
                style="display: ${this.display}; left: var(--ctx-l); top: var(--ctx-t);"
                >
                ${(this.contextOpts.length > 0) ?
            this.renderContextList(this.contextOpts)
            : /*until(this.contextPromise?.then(data=>{return this.renderContextList(data, true);}), this.renderContextItem({menuTxt: '...', eventTxt: ''}, 0))*/ ''}
            </div>
        `;
    }
    ;
};
__decorate([
    property({ attribute: 'mode' })
], PICContext.prototype, "mode_", void 0);
__decorate([
    property({ attribute: 'globflag' })
], PICContext.prototype, "globflag_", void 0);
__decorate([
    state()
], PICContext.prototype, "contextOpts", void 0);
__decorate([
    state()
], PICContext.prototype, "display", void 0);
__decorate([
    query('#pic-contextMenu')
], PICContext.prototype, "innerDiv", void 0);
PICContext = __decorate([
    customElement('pic-context')
], PICContext);
export { PICContext };
//# sourceMappingURL=PICContext.js.map